import { apiRequest } from '@department-of-veterans-affairs/platform-utilities/exports';
import recordEvent from 'platform/monitoring/record-event';
import {
  ONBOARDING_MODAL_EVENTS,
  ONBOARDING_MODAL_REQUESTS,
  ONBOARDING_MODAL_STATUS,
  ONBOARDING_MODAL_TITLE,
} from '../analytics';

export const FETCH_CLAIMS_ERROR = 'FETCH_CLAIMS_ERROR';
export const FETCH_CLAIMS_PENDING = 'FETCH_CLAIMS_PENDING';
export const FETCH_CLAIMS_SUCCESS = 'FETCH_CLAIMS_SUCCESS';

export const UPDATE_ONBOARDING_DISPLAY_ERROR =
  'UPDATE_ONBOARDING_DISPLAY_ERROR';
export const UPDATE_ONBOARDING_DISPLAY_PENDING =
  'UPDATE_ONBOARDING_DISPLAY_PENDING';
export const UPDATE_ONBOARDING_DISPLAY_SUCCESS =
  'UPDATE_ONBOARDING_DISPLAY_SUCCESS';

export const INIT_DISMISSED_MODALS = 'INIT_DISMISSED_MODALS';
export const DISMISS_MODAL = 'DISMISS_MODAL';
export const MARK_ONBOARDING_MODAL_SHOWN = 'MARK_ONBOARDING_MODAL_SHOWN';
export const SET_ONBOARDING_SHOW = 'SET_ONBOARDING_SHOW';

export function initDismissedModals(onboardingShow) {
  return {
    type: INIT_DISMISSED_MODALS,
    dismissed: false,
    show: onboardingShow === true,
  };
}

export function dismissModal() {
  return { type: DISMISS_MODAL };
}

export function markOnboardingModalShown() {
  return { type: MARK_ONBOARDING_MODAL_SHOWN };
}

export function setOnboardingShow(show) {
  return { type: SET_ONBOARDING_SHOW, show };
}

export const updateOnboardingDisplay = (
  shouldDisplayOnboardingFlow = false,
) => {
  return dispatch => {
    dispatch({ type: UPDATE_ONBOARDING_DISPLAY_PENDING });

    return apiRequest('/veteran_onboarding', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        // eslint-disable-next-line camelcase
        veteran_onboarding: {
          // eslint-disable-next-line camelcase
          display_onboarding_flow: shouldDisplayOnboardingFlow,
        },
      }),
    })
      .then(() => {
        dispatch({ type: UPDATE_ONBOARDING_DISPLAY_SUCCESS });
      })
      .catch(() => {
        recordEvent({
          event: ONBOARDING_MODAL_EVENTS.REQUEST_FAILED,
          'modal-title': ONBOARDING_MODAL_TITLE,
          'modal-status': ONBOARDING_MODAL_STATUS,
          'error-key': ONBOARDING_MODAL_REQUESTS.ONBOARDING_DISPLAY,
        });
        return dispatch({ type: UPDATE_ONBOARDING_DISPLAY_ERROR });
      });
  };
};

export const setOnboardingFlowAsSeen = () => updateOnboardingDisplay(false);

export const setOnboardingFlowToShow = () => updateOnboardingDisplay(true);

export const getClaims = () => {
  return dispatch => {
    dispatch({ type: FETCH_CLAIMS_PENDING });

    return apiRequest('/benefits_claims')
      .then(res => {
        dispatch({ type: FETCH_CLAIMS_SUCCESS, claims: res.data });
      })
      .catch(() => {
        recordEvent({
          event: ONBOARDING_MODAL_EVENTS.REQUEST_FAILED,
          'modal-title': ONBOARDING_MODAL_TITLE,
          'modal-status': ONBOARDING_MODAL_STATUS,
          'error-key': ONBOARDING_MODAL_REQUESTS.CLAIMS,
        });
        return dispatch({ type: FETCH_CLAIMS_ERROR });
      });
  };
};
